import { EDeviceTypes, FormItemTypes, isNullOrUndefined } from '@bimser/core';
import classNames from 'classnames/bind';
import React from 'react';
import Styles from './assets/styles.scss';
import Column from './Column';
import { ISection } from './entities';

const cx = classNames.bind(Styles);

const Section = (args: ISection) => {
	const {
		data,
		controlRenderManager,
		getItem,
		deviceType,
		paddingType,
		parentItemType,
		isControlVisible
	} = args;

	const sectionClassNames: string = cx({
		base: true,
		draggable: true,
		section: true
	});

	const columnsClassNames: string = cx({
		columns: true,
		extraSmall: deviceType === EDeviceTypes.ExtraSmall,
		isInputGroup: parentItemType === FormItemTypes.EControlTypes.InputGroup
	});

	const padding = data.designerProps.layout.get('padding');
	const noPadding = isNullOrUndefined(padding) || padding === '';
	const columnsContainsStyles: React.CSSProperties = noPadding
		? { padding: '0 0 0 0' }
		: {
				padding: padding
		  };

	const someChildrenVisible = data?.items.filter(isControlVisible);
	if (!someChildrenVisible.count()) {
		return null;
	}

	const columns = data.items
		.map((itemId: string) => {
			const item = getItem(itemId);

			if (item.type === FormItemTypes.EContainerTypes.Column) {
				const layout = item.designerProps.layout;
				const hidden = !(layout.get('visible') && layout.get('clientVisible'));

				if (!hidden) {
					return (
						<React.Fragment key={itemId}>
							{controlRenderManager(
								itemId,
								<Column
									key={item.id}
									data={item}
									getItem={getItem}
									controlRenderManager={controlRenderManager}
									deviceType={deviceType}
									paddingType={paddingType}
									parentItemType={parentItemType}
									isControlVisible={isControlVisible}
								/>
							)}
						</React.Fragment>
					);
				}
			}
		})
		.filter(element => element);

	if (!columns.count()) {
		return <></>;
	}

	return (
		<div className={sectionClassNames}>
			<div
				className={columnsClassNames}
				style={columnsContainsStyles}
			>
				{columns}
			</div>
		</div>
	);
};
export default Section;
